<template>
	<div class="my-4">
		<v-row no-gutters>
			<v-col md="12">
				<h2
					style="border-bottom: 1px solid black; border-top: 1px solid black; text-align:center;"
					class="pa-4 font-weight-light"
				>
					<strong>{{
						this.$props.type !== "Camp" ? "Guide Staff" : "Camp Counselors"
					}}</strong>
				</h2>
			</v-col>
		</v-row>
		<v-row no-gutters class="flex-nowrap" style="overflow: hidden">
			<v-col xs="1" sm="1" md="1">
				<div class="centerV" v-on:click="toggleLeft()">
					<v-btn text><v-icon x-large>keyboard_arrow_left</v-icon></v-btn>
				</div>
			</v-col>
			<v-row no-gutters class="flex-nowrap" style="overflow: hidden">
				<v-col
					xs="4"
					sm="4"
					md="4"
					v-for="(employee, index) in Employees"
					:key="index"
				>
					<v-card
						outlined
						tile
						raised
						inline-block
						class=" ma-4 card-overflow rounded grey lighten-3"
						max-height="450"
						scrollable
					>
						<v-img
							aspect-ratio="1.4"
							class="white--text align-end text-center text-uppercase"
							:src="employee.url"
						>
							<template v-slot:placeholder>
								<v-row class="fill-height ma-0" align="center" justify="center">
									<v-progress-circular
										indeterminate
										color="grey lighten-5"
									></v-progress-circular>
								</v-row>
							</template>
						</v-img>
						<h3 class="text-center pt-2">{{ employee.name }}</h3>
						<v-card-text max-height="5px" class="text-center"
							><b>{{ employee.position }}</b></v-card-text
						>
						<v-card-actions class="centered">
							<v-btn class="mx-10" icon @click="employee.show = !employee.show">
								Show Bio <v-icon> perm_identity </v-icon></v-btn
							>
						</v-card-actions>
						<v-expand-transition>
							<div v-show="employee.show">
								<v-divider></v-divider>
								<v-card-text>
									{{ employee.bio }}
								</v-card-text>
							</div>
						</v-expand-transition>
					</v-card>
				</v-col>
			</v-row>
			<v-col md="1">
				<div class="centerV" v-on:click="toggleRight()">
					<v-btn text><v-icon x-large>keyboard_arrow_right</v-icon></v-btn>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import fb from "@/fb";
export default {
	props: {
		type: {
			type: String,
		},
	},
	data() {
		return {
			Employees: [],
		};
	},
	methods: {
		toggleLeft: function() {
			var lastElementIndex = this.Employees.length - 1;
			var pushImage = this.Employees[lastElementIndex];
			this.images.pop();
			this.images.unshift(pushImage);
		},
		toggleRight: function() {
			var pushImage = this.Employees[0];
			this.Employees.shift();
			this.Employees.push(pushImage);
		},
	},
	async created() {
		const user = await fb.db.collection("users").get();
		user.docs.forEach((doc) => {
			if (
				this.$props.type !== "Camp" &&
				doc.data().employeeStatus === true &&
				doc.data().email != "lehu9098@colorado.edu"
			) {
				this.Employees.push({
					id: doc.id,
					name: doc.data().fullName,
					phone: doc.data().phoneNumber,
					bio: doc.data().bio,
					position: doc.data().position,
					show: false,
					url: doc.data().photoID,
				});
			} else if (
				this.$props.type === "Camp" &&
				doc.data().campCounselor === true &&
				doc.data().email != "lehu9098@colorado.edu"
			) {
				this.Employees.push({
					id: doc.id,
					name: doc.data().fullName,
					phone: doc.data().phoneNumber,
					bio: doc.data().bio,
					position: doc.data().position,
					show: false,
					url: doc.data().photoID,
				});
			}
		});
	},
};
</script>
<style scoped>
.v-card__text {
	padding: 5px;
}
.v-card__actions {
	padding: 0px;
}
.centerV {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
	padding: 5%;
}
.space {
	display: flex;
	justify-content: flex-end;
}
.title {
	text-align: center;
	border-bottom: 1px solid black;
	border-top: 1px solid black;
}
.card-overflow {
	overflow: scroll;
}
.centered {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
